module.exports = __webpack_public_path__ + "img/HelveticaNeueCyrBold.ffd6502.svg";